var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"form-section recaptcha"},[_c('span',{staticClass:"recaptcha-site-key",attrs:{"data-grecaptchaSiteKey":_vm.recaptchaKey}}),_vm._v(" "),_c('input',{attrs:{"id":"g-recaptcha-response","type":"hidden","name":"quotation_g-recaptcha-response"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }